export const appVersion = 'master_2024-06-02T14-53_4b5373f';
